import React, { useEffect, useRef, useState } from 'react'
import { BiChevronLeft, BiChevronRight } from "react-icons/bi"
import { VscCloudDownload } from "react-icons/vsc"
import { HiMenuAlt3 } from "react-icons/hi"
import {  MdClose } from "react-icons/md"

const Navbar = () => {
    const [hovered, setHovered] = useState()
    const [open, setOpen] = useState(false)

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
    useEffect(() => {
        window.addEventListener("resize", () => {
          const ismobile = window.innerWidth < 1200;
          if (ismobile !== isMobile) setIsMobile(ismobile);
        }, false);
      }, [isMobile]);

      const [currentId, setCurrentId] = useState('');

      useEffect(() => {
        const handleScroll = () => {
          const components = document.querySelectorAll('.main');
          for (const component of components) {
            const rect = component.getBoundingClientRect();
            if (rect.top <= window.innerHeight * 0.5 && rect.bottom >= window.innerHeight * 0.5) {
                setCurrentId(component.id);
              break;
            }
          }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
    
    

    //   useEffect(() => {
    //     const handleScroll = () => {
    //       const divElements = Array.from(document.querySelectorAll('.main'));
    //     //   console.log('divElements',divElements)
    //       for (let i = divElements.length - 1; i >= 0; i--) {
    //         const div = divElements[i];
    //         const rect = div.getBoundingClientRect();

    //         console.log("div", div)
    //         console.log('rect',rect)
    //         console.log('window.innerHeight',window.innerHeight)
    
    //         if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
    //           setCurrentId(div.id);
    //           break;
    //         }
    //       }
    //     };
    
    //     window.addEventListener('scroll', handleScroll);
    
    //     return () => {
    //       window.removeEventListener('scroll', handleScroll);
    //     };
    //   }, []);
    //   console.log('currentId',currentId)

    const handleDownload = () => {
        // Construct the URL to the PDF file
        const baseUrl = window.location.origin;
        // const pdfURL = process.env.PUBLIC_URL + '/VMADARAKA.pdf';
        const pdfURL = `${baseUrl}/VMADARAKA.pdf`;
    
        // Create a temporary anchor element to initiate the download
        const link = document.createElement('a');
        link.href = pdfURL;
        link.download = 'VMADARAKA.pdf'; // Optional: Set the downloaded file's name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    

  return (
    <div className={`w-screen  z-40 fixed bg-[#000000]`}>
        <div className={` container py-4 px-4 md:px-0 mx-auto w-full font-vic flex flex-row `}>
            <div className={`flex ${isMobile? 'flex-col gap-4':' flex-row items-center'} justify-between w-full `}>
                <div className={` text-white ${isMobile? 'w-full flex flex-row justify-between items-center':''}`}>
                    <p className='text-[24px] font-semibold'>Victor Madaraka </p>
                    {isMobile &&
                    <div onClick={() => setOpen(!open)} className="cursor-pointer">
                        {open ?
                            <MdClose size={30}/>
                        :<HiMenuAlt3 size={30}/>
                        }
                    </div>
                    }
                </div>
                <div className={`flex ${isMobile? 'flex-col':' flex-row '} ${isMobile && open && 'block'} ${isMobile && !open && 'hidden'} gap-4`}>
                    <a href='#home' onMouseEnter={() => setHovered(0)}
                    onMouseLeave={() => setHovered()}
                    className={`${hovered === 0  || currentId==='home'? 'text-teal-300':'text-white'} flex flex-row items-center cursor-pointer`}>
                        { hovered ===0 || currentId==='home' && <BiChevronLeft size={20}/>}
                        <p className="tracking-widest">Home</p>
                        { hovered ===0 || currentId==='home' && <BiChevronRight size={20}/>}
                    </a>
                    <a href="#skills" onMouseEnter={() => setHovered(1)}
                    onMouseLeave={() => setHovered()}
                    className={`${hovered ===1 || currentId==='skills'? 'text-teal-300':'text-white'} flex flex-row items-center cursor-pointer`}>
                        { hovered ===1 || currentId==='skills' && <BiChevronLeft size={20}/>}
                        <p className="tracking-widest">Skills</p>
                        { hovered ===1 || currentId==='skills' && <BiChevronRight size={20}/>}
                    </a>
                    <a href='#experience' onMouseEnter={() => setHovered(2)}
                    onMouseLeave={() => setHovered()}
                    className={`${hovered ===2 || currentId==='experience'? 'text-teal-300':'text-white'} flex flex-row items-center cursor-pointer`}>
                        {hovered ===2 || currentId==='experience' && <BiChevronLeft size={20}/>}
                        <p className="tracking-widest">Experience</p>
                        {hovered ===2 || currentId==='experience' && <BiChevronRight size={20}/>}
                    </a>
                    <a href='#portfolio' onMouseEnter={() => setHovered(3)}
                    onMouseLeave={() => setHovered()}
                    className={`${hovered === 3 || currentId==='portfolio'? 'text-teal-300':'text-white'} flex flex-row items-center cursor-pointer`}>
                        {hovered ===3 || currentId==='portfolio' && <BiChevronLeft size={20}/>}    
                        <p className="tracking-widest">Projects</p>
                        {hovered ===3 || currentId==='portfolio' && <BiChevronRight size={20}/>}
                    </a>
                </div>
                <div className={`${isMobile && open && 'block'}  ${isMobile && !open && 'hidden'} flex items-center flex-row `}>
                    <div onClick={handleDownload} className="flex text-white flex-row gap-2 px-6 py-2 items-center bg-gray-500 rounded-full shadow-2xl cursor-pointer">
                        <p className='tracking-widest'>Resume</p>
                        <VscCloudDownload size={20}/>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Navbar